
import { Component, namespace, Vue } from 'bits/vue'
import OzBaseSnackbar from 'library/v4/components/OzBaseSnackbar.vue'
import { GlobalSnackbarNotificationVuex } from 'vuexstore/modules/global_snackbar'

const globalSnackbar = namespace('globalSnackbar')

@Component({
  components: { OzBaseSnackbar },
})
export default class GlobalSnackbarVuex extends Vue {
  @globalSnackbar.Getter snackbarArray!: GlobalSnackbarNotificationVuex[]
  @globalSnackbar.Action executeActions

  calculateSnackbarPosition(snackbarIndex: number): string {
    const actualIndex = snackbarIndex - Math.min(...this.snackbarArray.map((snackbar) => snackbar.originalIndex))
    // 49 is the height of snackbar plus margin between snackbars
    // each subsequent snackbar is height plus margin of a snackbar from the top of the viewport plus initial gap (16px)
    return `${(this.snackbarArray.length - actualIndex) * 49 - 16}px`
  }
}
